import { Link } from "react-router-dom";
import type { Article } from "@/types/news";
import { formatViews } from "@/utils/news";

interface HotListProps {
  items: Article[];
}

export default function HotList({ items }: HotListProps) {
  return (
    <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-fire-line text-primary-500"></i>
          热门推荐
        </h3>
        <span className="text-xs text-foreground-400">按热度排序</span>
      </div>
      <ol className="flex flex-col divide-y divide-background-200">
        {items.map((item, index) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex cursor-pointer items-start gap-3 py-3.5 first:pt-0 last:pb-0"
            >
              <span
                className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                  index < 3
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-500"
                }`}
              >
                {index + 1}
              </span>
              <span className="flex-1">
                <span className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  {formatViews(item.views)} 次浏览
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </aside>
  );
}